// Текстовки для интро панели

const DO_YOU_WANT = "Хочешь, чтобы твой любимый мультфильм, телеведущий или ТВ-проект победил в Премии?"
const GIVE_YOUR_VOICE = "Заполняй форму и предлагай нам своих претендентов!"
const MAY_BE = "Возможно, именно они станут Главными Героями этого года!"

export const INTRO_TEXT = [DO_YOU_WANT, GIVE_YOUR_VOICE, MAY_BE]

// Константы для веба

export const VK_MINI_APP_ID = 51549281
export const VK_MINI_APP_ID_TEST = 51696453
export const APP_URL = "https://vk.com/app51549281"
// export const APP_URL = 'https://vk.com/app51696453'; // Тестовое

export const VK_SHARE_URL = `https://vk.com/app${VK_MINI_APP_ID}`
export const VK_SHARE_TITLE = "Я выбрал главных героев! А ты?"

export const WEB_SHARE_URL = `https://www.karusel-tv.ru/${APP_URL}`
export const WEB_SHARE_TITLE = "Я выбрал главных героев! А ты?"

export const MAP_LABEL_NOMINANTS = {
  vedusch: "Главный ведущий или ведущая",
  kids_parent: "Главный детский проект. Выбор родителей",
  kids_vedusch: "Главный ребёнок ведущий",
  song: "Главная песня",
  ispolnitel: "Главный исполнитель",
  blogger: "Главный блогер",
  aktor: "Главный актёр (дети и взрослые)",
  film: "Главный фильм",
  kids_programm: "Главный детский проект (программа)",
  anim_series: "Главный анимационный сериал",
  prem_anim_serial: "Главная премьера анимационного сериала",
  hero: "Главный герой",
}
